import {groupBy} from 'lodash-es';

import type {
  AfriexCurrencyCode,
  AfriexRate,
  RatesMap,
  RatesValueMap,
} from '@/types';

const currencyOrder = [
  'USD',
  'GBP',
  'EUR',
  'CAD',
  'NGN',
  'GHS',
  'KES',
  'UGX',
  'XAF',
  'ETB',
  'HTG',
  'GNF',
  'XOF',
  'EGP',
  'MXN',
  'PHP',
  'CNY',
  'INR',
  'PKR',
  'RWF',
  'ZAR',
  'TZS',
  'ZMW',
  'MGA',
  'MWK',
  'MZN',
] as const;

export const convertOrderedRatesListToMap = (rates: AfriexRate[]): RatesMap => {
  const collapseRates = (arr: AfriexRate[]): RatesValueMap =>
    arr.reduce((acc, x) => ({...acc, [x.toSymbol]: x.value}), {});

  const ratesByBase = groupBy(rates, (rate) => rate.fromSymbol);

  const ratesToReturn: Partial<Record<AfriexCurrencyCode, RatesValueMap>> = {};

  for (const currency of currencyOrder) {
    if (ratesByBase[currency]) {
      ratesToReturn[currency as AfriexCurrencyCode] = collapseRates(
        ratesByBase[currency],
      );
    }
  }

  return ratesToReturn;
};

export const convertRatesListToMap = (rates: AfriexRate[]): RatesMap => {
  const collapseRates = (arr: AfriexRate[]): RatesValueMap =>
    arr.reduce((acc, x) => ({...acc, [x.toSymbol]: x.value}), {});

  const ratesToReturn: Partial<Record<AfriexCurrencyCode, RatesValueMap>> = {};
  const ratesByBase = groupBy(rates, (rate) => rate.fromSymbol);
  for (const [key, value] of Object.entries(ratesByBase)) {
    ratesToReturn[key as AfriexCurrencyCode] = collapseRates(value);
  }

  return ratesToReturn;
};
